import { createSelector } from '@ngrx/store';
import { selectCaseState } from './common-case.selector';

export const selectCaseInformations = createSelector(
  selectCaseState,
  (state) => state.case.caseInformations
);

export const selectCasePriceType = createSelector(
  selectCaseState,
  (state) => state.case.caseInformations?.priceType ?? null
);
